import { EntityConfig } from '@components-fabric';

export const spaceFunctionsPresetsEntity: EntityConfig<any> = {
  id: 'spaces',
  columns: ['id', 'name'],
  endpoints: '/buildingms/presets',
  name: 'SpaceFunctionsPresets',
  // layout: layoutWorkspace,
  schema: {},
  empty: {},
};
